import { render, staticRenderFns } from "./PropertyBankDetails.vue?vue&type=template&id=6954a07c&scoped=true"
import script from "./PropertyBankDetails.vue?vue&type=script&lang=js"
export * from "./PropertyBankDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6954a07c",
  null
  
)

export default component.exports